/**
 * Demo data for an empty workspace.
 *
 * Every date is stored as an offset in days from "now" rather than a fixed
 * date, so the sample book looks live whenever someone opens it — trials are
 * genuinely ending this week, invoices are genuinely overdue.
 */
import { formatDate, addDays } from '../lib/dates.js';

const TIMES = ['09:14', '10:59', '11:32', '13:05', '14:48', '16:20', '17:03', '08:47', '12:15', '15:37'];

/*
 * [ name, email, type, regOffset, source, plan, trialOffset | 'No trial' | null,
 *   expiryOffset | null, cycle, promo, pay, status, owner, contact,
 *   activityOffset | null, contactedOffset | null, notes ]
 */
const CLIENT_ROWS = [
  ["Al Barsha Trading L.L.C", "accounts@albarshatrading.ae", "Paying", -310, "Direct", "GROWTH", null, 55, "Annual", "LAUNCH20", "YES", "Active", "Agalya", "Nadia Haddad", -2, -40, "Annual GROWTH at AED 950. Renewal call booked for Sept."],
  ["Gulf Horizon Contracting", "finance@gulfhorizon.ae", "Paying", -268, "Referral", "SUITE", null, 97, "Annual", "", "YES", "Active", "BK", "Omar Farooq", -1, -25, "Uses Inventory + Expenses heavily. Candidate for case study."],
  ["Nova Interiors FZ-LLC", "hello@novainteriors.ae", "Paying", -201, "Website", "STARTER", null, 164, "Annual", "", "YES", "Active", "Sana", "Priya Menon", -4, -60, "Migrated from Zoho Books in Feb."],
  ["Emirates Logistics Hub", "ap@emlogistics.ae", "Paying", -155, "Partner", "SUITE", null, 210, "Annual", "PARTNER15", "YES", "Active", "Rahul", "Yusuf Al Marri", -1, -15, "Partner-sourced. 15% partner discount applied."],
  ["Zayed Medical Supplies", "accounts@zayedmedical.ae", "Paying", -142, "Direct", "GROWTH", null, 223, "Annual", "FTA2026", "YES", "Active", "Agalya", "Dr. Sameer Nair", -3, -30, "VAT 201 filing is the main draw."],
  ["Palm Cafe Group", "finance@palmcafegroup.ae", "Paying", -98, "Walk-in", "STARTER", null, 267, "Annual", "", "YES", "Active", "Fatima", "Layla Hassan", -6, -48, "Three outlets under one org."],
  ["Desert Rose Events", "billing@desertroseevents.ae", "Paying", -121, "Social Media", "GROWTH", -107, 12, "Monthly", "GITEX26", "YES", "Active", "Sana", "Mariam Al Zaabi", -2, -20, "Monthly GROWTH. Converted on day 12 of trial."],
  ["Sharjah Auto Spares", "accounts@sharjahautospares.ae", "Paying", -89, "Direct", "STARTER", -75, 9, "Monthly", "", "YES", "Active", "Rahul", "Bilal Ahmed", -5, -33, ""],
  ["Bright Minds Tutoring", "admin@brightmindstutoring.ae", "Paying", -76, "Website", "STARTER", -62, 4, "Monthly", "", "YES", "Active", "Fatima", "Ritu Sharma", -3, -11, "Renewal in 4 days — card on file expires soon."],
  ["Coastline Marine Services", "finance@coastlinemarine.ae", "Paying", -64, "Referral", "SUITE", -50, 18, "Monthly", "", "YES", "Active", "BK", "Hamdan Al Suwaidi", -1, -9, "Upgraded FREE → SUITE after demo."],
  ["Urban Fit Studios", "accounts@urbanfitstudios.ae", "Paying", -52, "Social Media", "STARTER", -38, 7, "Monthly", "RAMADAN30", "YES", "Active", "Agalya", "Sara Iqbal", -8, -22, "Promo RAMADAN30 applied to first month."],
  ["Falcon Freight L.L.C", "ap@falconfreight.ae", "Paying", -349, "Direct", "GROWTH", null, 16, "Annual", "LAUNCH20", "YES", "Active", "Rahul", "Khalid Bin Saeed", -12, -70, "Annual renewal in 16 days. Wants a multi-org quote."],
  ["Marina Bay Realty", "finance@marinabayrealty.ae", "Paying", -357, "Website", "SUITE", null, 8, "Annual", "", "PENDING", "Active", "Sana", "Aisha Rahman", -9, -6, "Invoice issued, awaiting bank transfer."],
  ["Oasis Landscaping", "accounts@oasislandscaping.ae", "Paying", -372, "Walk-in", "STARTER", null, -7, "Annual", "", "OVERDUE", "Active", "", "Tariq Mahmood", -30, -52, "EXPIRED a week ago and unowned. Needs an owner today."],
  ["Skyline Architects FZE", "billing@skylinearchitects.ae", "Paying", -390, "Referral", "GROWTH", null, -25, "Annual", "", "NO", "Active", "Fatima", "Ivan Petrov", -44, -38, "Expired 25 days ago. Two emails sent, no reply."],
  ["Cedar & Co Consultancy", "hello@cedarco.ae", "Trial", -2, "Website", "STARTER", 12, null, "-", "", "NO", "Trial", "Agalya", "Joseph Mathew", 0, null, "Signed up after the pricing page. No card required."],
  ["Ruby Textiles Trading", "info@rubytextiles.ae", "Trial", -4, "Direct", "GROWTH", 10, null, "-", "GITEX26", "NO", "Trial", "BK", "Anita Desai", -1, null, "Came from GITEX follow-up list."],
  ["Quantum Tech Labs", "accounts@quantumtechlabs.ae", "Trial", -6, "Social Media", "SUITE", 8, null, "-", "", "NO", "Trial", "Sana", "Wei Chen", 0, null, "Testing Inventory and CFO modules."],
  ["Golden Sands Tourism", "finance@goldensands.ae", "Trial", -9, "Referral", "GROWTH", 5, null, "-", "", "NO", "Trial", "Rahul", "Noura Al Hashimi", -1, null, "Asked about VAT 201 direct upload."],
  ["Pearl Catering Services", "admin@pearlcatering.ae", "Trial", -11, "Campaign", "STARTER", 3, null, "-", "", "NO", "Trial", "Fatima", "Ahmed Zaki", -2, null, "Trial ends in 3 days — send the conversion email."],
  ["Vertex Engineering L.L.C", "info@vertexeng.ae", "Trial", -12, "Website", "GROWTH", 2, null, "-", "", "PENDING", "Trial", "Agalya", "Suresh Pillai", 0, null, "Quote requested for 10 users. Hot."],
  ["Lumen Digital Agency", "hello@lumendigital.ae", "Trial", -13, "Partner", "SUITE", 1, null, "-", "PARTNER15", "NO", "Trial", "", "Grace Okafor", -1, null, "Trial ends tomorrow and nobody owns this account."],
  ["Nile Star General Trading", "accounts@nilestar.ae", "Trial", -14, "Direct", "STARTER", 0, null, "-", "", "NO", "Trial", "BK", "Mostafa Kamal", -3, null, "Trial ends today. Call before 5pm."],
  ["Crescent Interiors", "info@crescentinteriors.ae", "Trial", -21, "Website", "STARTER", -7, null, "-", "", "NO", "Active", "Sana", "Hind Al Ali", -8, -3, "Trial ended a week ago. Chased on Wednesday, waiting."],
  ["Blue Wave Shipping", "finance@bluewaveshipping.ae", "Trial", -28, "Direct", "GROWTH", -14, null, "-", "", "NO", "Active", "Rahul", "Peter Nunes", -16, null, "Trial ended 2 weeks ago, never contacted."],
  ["Harmony Interiors FZ", "hello@harmonyint.ae", "Trial", -34, "Social Media", "STARTER", -20, null, "-", "", "NO", "Inactive", "Fatima", "Zainab Sheikh", -21, -19, "Went quiet after the trial. Low intent."],
  ["Titan Steel Trading", "ap@titansteel.ae", "Trial", -41, "Campaign", "SUITE", -27, null, "-", "", "NO", "Active", "", "Reza Khan", -29, null, "Unowned, unpaid, unactive. Worst-case row."],
  ["Sunrise Pharmacy Group", "accounts@sunrisepharmacy.ae", "Trial", -47, "Referral", "GROWTH", -33, null, "-", "FTA2026", "NO", "On Hold", "Agalya", "Dilnaz Ibrahim", -33, -2, "Asked to be re-approached after their audit."],
  ["Nadeem Auto Garage", "nadeem.garage@gmail.com", "Free", -60, "Direct", "FREE", "No trial", null, "-", "", "N/A", "Active", "Fatima", "Nadeem Qureshi", -7, null, "On the free-for-1-year plan. Upsell at month 9."],
  ["Sadiq Brothers Grocery", "sadiqbros@gmail.com", "Free", -73, "Walk-in", "FREE", "No trial", null, "-", "", "N/A", "Active", "", "Sadiq Ali", -14, null, "No contact person recorded and no owner."],
  ["The Craft Bakery", "hello@thecraftbakery.ae", "Free", -84, "Social Media", "FREE", "No trial", null, "-", "", "N/A", "Active", "Sana", "Elena Roshkova", -4, null, "Two users. Asked about invoicing limits."],
  ["Horizon Freelance Hub", "horizonhub@gmail.com", "Free", -95, "Website", "FREE", "No trial", null, "-", "", "N/A", "Active", "BK", "Imran Vora", -41, null, "No activity in 6 weeks — likely dormant."],
  ["Mira Design Studio", "mira@miradesign.ae", "Free", -112, "Referral", "FREE", "No trial", null, "-", "", "N/A", "Active", "Agalya", "Mira Fernandes", -9, -35, "Good upgrade candidate — asked about OCR."],
  ["Al Noor Stationery", "alnoorstat@gmail.com", "Free", -130, "Direct", "FREE", "No trial", null, "-", "", "N/A", "Inactive", "Fatima", "Bashir Haque", -64, null, "Dormant since April."],
  ["Everest Manpower Supply", "finance@everestmanpower.ae", "Paying", -402, "Direct", "STARTER", null, -38, "Annual", "", "REFUNDED", "Churned", "Rahul", "Ganesh Iyer", -52, -36, "Churned — moved to an in-house accountant."],
  ["Silver Line Trading", "accounts@silverlinetrading.ae", "Trial", -96, "Campaign", "GROWTH", -82, null, "-", "", "FAILED", "Churned", "Sana", "Marwan Fadel", -80, -74, "Card failed twice during trial conversion."],
  ["Apex Cargo Movers", "info@apexcargo.ae", "Paying", -330, "Reseller", "GROWTH", null, -62, "Annual", "ACCTFIRM10", "NO", "Expired", "BK", "Sunil Raghavan", -70, -58, "Expired two months ago. Reseller deal, low margin."],
  ["Meridian Chartered Accountants", "ops@meridianca.ae", "Paying", -186, "Partner", "SUITE", null, 179, "Annual", "ACCTFIRM10", "YES", "Active", "BK", "Vivek Anand", -1, -10, "Accounting firm managing 14 client orgs. Key account."],
  ["Al Fahad Auditing", "admin@alfahadaudit.ae", "Paying", -174, "Reseller", "GROWTH", null, 191, "Annual", "ACCTFIRM10", "YES", "Active", "Rahul", "Hessa Al Fahad", -6, -27, "Reseller of record for 6 SMEs."],
  ["The Social Platter L.L.C FZ", "social.platter.du@gmail.com", "Internal", -102, "Direct", "FREE", "No trial", null, "-", "67KUEKJA", "N/A", "Active", "BK", "Agalya", -3, null, "Internal account — excluded from conversion and payment chasing."],
  ["XYRA Demo Company", "demo@thexyra.ai", "Test", -220, "Direct", "SUITE", "No trial", null, "-", "", "N/A", "Active", "BK", "Sales Team", 0, null, "Demo org used on sales calls. Do not chase."],
  ["XYRA QA Sandbox", "qa@thexyra.ai", "Test", -240, "Direct", "GROWTH", "No trial", null, "-", "", "N/A", "Active", "BK", "QA Team", -1, null, "Regression testing org."],
];

/** Build the 42 sample clients. `S` supplies plan prices and the date format. */
export function buildClientSeed(S) {
  const now = new Date();
  const fmt = d => formatDate(d, false, S.dateFmt);
  const priceOf = plan => {
    const p = (S.prices || {})[String(plan || '').toUpperCase()];
    return typeof p === 'number' ? p : 0;
  };

  return CLIENT_ROWS.map((r, i) => {
    const annual = String(r[8]).toLowerCase() === 'annual';
    const paying = r[2] === 'Paying' && r[7] !== null;
    const lastPaid = paying ? fmt(addDays(now, r[7] - (annual ? 365 : 30))) : '';

    return {
      id: `seed-${i + 1}`,
      sno: i + 1,
      name: r[0],
      email: r[1],
      acctType: r[2],
      regOn: `${fmt(addDays(now, r[3]))} ${TIMES[i % TIMES.length]}`,
      source: r[4],
      plan: r[5],
      trialEnd: typeof r[6] === 'string' ? r[6] : (r[6] === null ? '' : fmt(addDays(now, r[6]))),
      expiry: r[7] === null ? '-' : fmt(addDays(now, r[7])),
      cycle: r[8],
      promo: r[9],
      pay: r[10],
      status: r[11],
      handler: r[12],
      contact: r[13],
      phone: `+9715${String(20345678 + i * 111317).slice(0, 8)}`,
      addons: String(r[5]).toUpperCase() === 'SUITE'
        ? ''
        : (i % 5 === 0 && priceOf(r[5]) > 0)
          ? 'XYRA Inventory'
          : (i % 7 === 0 && priceOf(r[5]) > 0) ? 'XYRA CFO; XYRA Expenses' : '',
      amount: '',
      nextDue: paying ? fmt(addDays(now, r[7])) : '',
      lastPaid,
      pays: paying ? [{ d: lastPaid, amt: 0 }] : [],
      lastActivity: r[14] === null ? '' : fmt(addDays(now, r[14])),
      lastContacted: r[15] === null ? '' : fmt(addDays(now, r[15])),
      notes: r[16]
    };
  });
}

/* -------------------------------------------------------------- pipeline */

/* [ name, industry, size, city, owner ] */
const COMPANY_ROWS = [
['Al Barsha Trading L.L.C','Trading','25 staff','Dubai','Agalya'],
    ['Gulf Horizon Contracting','Contracting','120 staff','Sharjah','BK'],
    ['Nova Interiors FZ-LLC','Professional services','14 staff','Dubai','Sana'],
    ['Emirates Logistics Hub','Logistics','80 staff','Jebel Ali','Rahul'],
    ['Zayed Medical Supplies','Healthcare','40 staff','Abu Dhabi','Agalya'],
    ['Palm Cafe Group','Hospitality','60 staff','Dubai','Fatima'],
    ['Desert Rose Events','Professional services','18 staff','Dubai','Sana'],
    ['Falcon Freight L.L.C','Logistics','95 staff','Dubai','Rahul'],
    ['Marina Bay Realty','Real estate','30 staff','Dubai','Sana'],
    ['Quantum Tech Labs','Professional services','22 staff','Dubai','BK'],
    ['Sunrise Pharmacy Group','Healthcare','55 staff','Ajman','Agalya'],
    ['Titan Steel Trading','Trading','70 staff','Sharjah','Fatima'],
];

/* [ name, title, email, phone, companyId, status, source, owner ] */
const CONTACT_ROWS = [
['Nadia Haddad','Finance Manager','nadia@albarshatrading.ae','+971501234501','co1','Customer','Referral','Agalya'],
    ['Omar Farooq','CFO','omar@gulfhorizon.ae','+971501234502','co2','Customer','Website','BK'],
    ['Priya Menon','Accountant','priya@novainteriors.ae','+971501234503','co3','Qualified','Website','Sana'],
    ['Yusuf Al Marri','Operations Head','yusuf@emlogistics.ae','+971501234504','co4','Qualified','Partner','Rahul'],
    ['Dr. Sameer Nair','Owner','sameer@zayedmedical.ae','+971501234505','co5','Contacted','Referral','Agalya'],
    ['Layla Hassan','Finance Lead','layla@palmcafegroup.ae','+971501234506','co6','Qualified','Campaign','Fatima'],
    ['Mariam Al Zaabi','Director','mariam@desertroseevents.ae','+971501234507','co7','Contacted','Social Media','Sana'],
    ['Khalid Bin Saeed','Managing Partner','khalid@falconfreight.ae','+971501234508','co8','Qualified','Direct','Rahul'],
    ['Aisha Rahman','Finance Manager','aisha@marinabayrealty.ae','+971501234509','co9','New','Website','Sana'],
    ['Wei Chen','CTO','wei@quantumtechlabs.ae','+971501234510','co10','New','Campaign','BK'],
    ['Dilnaz Ibrahim','Head of Finance','dilnaz@sunrisepharmacy.ae','+971501234511','co11','Nurturing','Referral','Agalya'],
    ['Reza Khan','Owner','reza@titansteel.ae','+971501234512','co12','New','Direct',''],
];

/* [ title, companyId, contactId, stage, value, closeOffset, owner, source, plan, cycle, nextStep ] */
/*
 * Demo requests the tracker has brought in, at the stage somebody left them.
 *
 * No value on any of them: nobody has picked a plan, so pricing one here would
 * be inventing the number the board exists to find out.
 *
 * [title, company, stage, source, interested-in, days-ago]
 */
const LEAD_ROWS = [
  ['Imran Haque', 'co3', 'New', 'Website', 'Books', -1],
  ['Priya Raman', '', 'New', 'Campaign', 'Payroll', -2],
  ['Khalid Al Mansoori', 'co8', 'New', 'Website', 'Inventory +1', -3],
  ['sara.dsouza', '', 'New', 'Social Media', '', -5],
  ['Ahmed Nasser', 'co4', 'Qualified', 'Website', 'CFO', -8],
  ['Lakshmi Iyer', '', 'Qualified', 'Referral', 'Books +2', -11],
  ['Demo request', '', 'Demo', 'Website', '', -14],
  ['Yusuf Rahman', 'co12', 'Demo', 'Partner', 'Expenses', -17],
  ['Meera Krishnan', '', 'Proposal', 'Campaign', 'Payroll +1', -21],
  ['info@dubai-traders', '', 'Lost', 'Website', '', -26],
  ['test test', '', 'Lost', 'Direct', '', -33]
];

const DEAL_ROWS = [
['Al Barsha — SUITE upgrade','co1','ct1','Negotiation',22920,-3,'Agalya','Referral','SUITE','Annual','Send revised annual quote'],
    ['Gulf Horizon — renewal + Inventory','co2','ct2','Proposal',14300,9,'BK','Website','SUITE','Annual','Follow up on the inventory demo'],
    ['Nova Interiors — GROWTH annual','co3','ct3','Demo',11400,14,'Sana','Website','GROWTH','Annual','Book the finance walkthrough'],
    ['Emirates Logistics — SUITE','co4','ct4','Negotiation',22920,4,'Rahul','Partner','SUITE','Annual','Agree the partner margin'],
    ['Zayed Medical — GROWTH','co5','ct5','Qualified',11880,21,'Agalya','Referral','GROWTH','Annual','Send the VAT 201 one-pager'],
    ['Palm Cafe — multi-outlet','co6','ct6','Proposal',17160,11,'Fatima','Campaign','SUITE','Annual','Chase the signed proposal'],
    ['Desert Rose — STARTER','co7','ct7','Demo',588,17,'Sana','Social Media','STARTER','Monthly',''],
    ['Falcon Freight — GROWTH annual','co8','ct8','Qualified',11400,28,'Rahul','Direct','GROWTH','Annual','Qualify the budget holder'],
    ['Marina Bay — SUITE trial','co9','ct9','New',23880,35,'Sana','Website','SUITE','Annual',''],
    ['Quantum Tech — GROWTH','co10','ct10','New',11880,42,'BK','Campaign','GROWTH','Annual',''],
    ['Sunrise Pharmacy — GROWTH','co11','ct11','Demo',11880,-8,'Agalya','Referral','GROWTH','Annual','Re-engage after their audit'],
    ['Titan Steel — STARTER','co12','ct12','New',588,25,'','Direct','STARTER','Monthly',''],
    ['Palm Cafe — pilot outlet','co6','ct6','Won',588,-34,'Fatima','Campaign','STARTER','Monthly',''],
    ['Gulf Horizon — Books rollout','co2','ct2','Won',11400,-21,'BK','Website','GROWTH','Annual',''],
    ['Zayed Medical — pilot','co5','ct5','Won',588,-12,'Agalya','Referral','STARTER','Monthly',''],
    ['Marina Bay — Inventory','co9','ct9','Won',11880,-6,'Sana','Website','GROWTH','Annual',''],
    ['Desert Rose — SUITE upsell','co7','ct7','Lost',17160,-45,'Sana','Social Media','SUITE','Annual',''],
    ['Titan Steel — SUITE','co12','ct12','Lost',22920,-60,'Fatima','Direct','SUITE','Annual',''],
];

/* [ subject, type, dealId, owner, dueOffset, done ] */
const ACTIVITY_ROWS = [
['Discovery call','Call','d1','Agalya',-9,true],['Sent annual quote','Email','d1','Agalya',-3,true],
    ['Chase the signature','Call','d1','Agalya',0,false],['Inventory demo','Demo','d2','BK',-6,true],
    ['Send implementation plan','Email','d2','BK',2,false],['Intro call','Call','d3','Sana',-11,true],
    ['Finance walkthrough','Demo','d3','Sana',3,false],['Partner intro','Meeting','d4','Rahul',-14,true],
    ['Margin discussion','Call','d4','Rahul',-1,false],['Referral follow-up','WhatsApp','d5','Agalya',-4,true],
    ['Site visit','Meeting','d6','Fatima',-8,true],['Proposal chase','Email','d6','Fatima',1,false],
    ['Demo booked','Demo','d7','Sana',-2,true],['Cold call','Call','d8','Rahul',-21,true],
    ['Budget qualification','Call','d8','Rahul',5,false],['Trial started','Note','d9','Sana',-3,true],
    ['Post-audit check-in','Call','d11','Agalya',-25,true],
];

/** Build the sample pipeline: companies, contacts, deals and activities. */
export function buildCrmSeed(S) {
  const now = new Date();
  const at = offset => formatDate(addDays(now, offset), false, S.dateFmt);

  return {
    companies: COMPANY_ROWS.map((x, i) => ({
      id: `co${i + 1}`, name: x[0], industry: x[1], size: x[2], city: x[3], owner: x[4], web: ''
    })),
    contacts: CONTACT_ROWS.map((x, i) => ({
      id: `ct${i + 1}`, name: x[0], title: x[1], email: x[2], phone: x[3],
      cid: x[4], status: x[5], source: x[6], owner: x[7], notes: ''
    })),
    /* One list. `kind` is 'lead' while a row is still being worked on the
       board and 'deal' once it has been won, which is what the Deals page
       lists. */
    deals: [
      ...DEAL_ROWS.map((x, i) => ({
        /* Every other one came in through the tracker. Those are on the board
           until won, and deals from then on; the rest were typed in by hand
           and are deals from the first, whatever stage they sit at. */
        id: `d${i + 1}`,
        origin: i % 2 ? 'vizadtraq' : '',
        kind: (i % 2 && x[3] !== 'Won') ? 'lead' : 'deal',
        title: x[0], cid: x[1], contact: x[2], stage: x[3], value: x[4],
        close: at(x[5]), owner: x[6], source: x[7], plan: x[8], cycle: x[9],
        next: x[10], notes: '', created: at(x[5] - 45)
      })),
      ...LEAD_ROWS.map((x, i) => {
        /* The notes in the shape the sync writes them, so the offline board
           shows the same email, phone and landing page the live one does. */
        const slug = x[0].toLowerCase().replace(/[^a-z]+/g, '.').replace(/^\.|\.$/g, '');
        const city = ['Dubai', 'Abu Dhabi', 'Sharjah', 'Chennai'][i % 4];
        const country = city === 'Chennai' ? 'India' : 'United Arab Emirates';
        const page = ['/pricing', '/demo', '/', '/features/books'][i % 4];
        const iso = addDays(now, x[5]).toISOString().slice(0, 10);
        /* Back once or twice for some of them, and only the once for the
           rest — the board's Engagement column is there to tell those apart,
           and a seed where everybody visited exactly once cannot show it. */
        const visits = [1, 3, 1, 2, 5, 1][i % 6];
        /* Full instants, as the tracker stamps them — it returns the minute,
           and the board prints it. A seed of bare days would show every lead
           arriving at midnight. */
        /* Not `at` — that name is already the day formatter this file uses
           for close dates, and shadowing it turned `created: at(x[5])` into a
           call to this one with no hour, which is an Invalid Date. */
        const stampAt = (offset, hour) => {
          const t = addDays(now, offset);
          t.setHours(hour, (offset * 17 + hour * 7 + 60) % 60, 0, 0);
          return t.toISOString();
        };
        const firstAt = stampAt(x[5], 9 + (i % 9));
        const lastAt = stampAt(x[5] + Math.min(visits - 1, 3), 11 + (i % 7));
        /* Which form, and whether they finished it. Six kinds reach this
           board and both states do, so the seed carries both — otherwise the
           Enquiry and Form filters have nothing to offer. */
        const type = ['Demo Request', 'Demo Request', 'Chatbot', 'Contact',
          'Demo Request', 'WhatsApp'][i % 6];
        const state = (i % 3 === 1 || type === 'WhatsApp')
          ? 'partially_submitted' : 'submitted';
        const campaign = i % 3 === 0 ? 'sept-launch' : '';

        return {
          id: `l${i + 1}`, kind: 'lead', title: x[0], cid: x[1], contact: '', stage: x[2],
          value: 0, close: '', owner: '', source: x[3], plan: x[4], cycle: '',
          next: 'Call to book the demo slot',
          leadType: type,
          leadState: state,
          /*
           * Exactly what trackerSync.intelFor() writes into deals.lead_intel.
           *
           * The notes paragraph below is kept as well, and says the same
           * thing in prose, because that is what the live rows look like too:
           * intel is read first and the paragraph is the fallback for rows
           * synced before the column existed. A seed that carried only one of
           * the two would leave half the reading path untested.
           */
          intel: {
            type, state, types: [type], sources: [x[3]], source: x[3],
            email: `${slug}@example.com`,
            phone: `+971 5${i}0 ${100 + i * 7} ${2000 + i * 31}`,
            google: null, network: 'Etisalat', networkDomain: '', linkedin: '',
            country, region: city === 'Chennai' ? 'Tamil Nadu' : 'Dubai', city,
            device: ['Desktop', 'Mobile', 'Desktop', 'Tablet'][i % 4],
            browser: ['Chrome', 'Safari', 'Edge', 'Chrome'][i % 4],
            os: ['Windows', 'iOS', 'macOS', 'Android'][i % 4],
            utm: campaign
              ? { source: 'google', medium: 'cpc', campaign, term: '', content: '' }
              : { source: '', medium: '', campaign: '', term: '', content: '' },
            landing: `https://thexyra.ai${page}`,
            exit: `https://thexyra.ai${i % 2 ? '/book-demo' : page}`,
            referrer: i % 3 === 0 ? 'https://www.google.com/' : '',
            pages: [1, 4, 2, 3, 6, 1][i % 6],
            seconds: [12, 217, 64, 138, 402, 9][i % 6],
            ad: campaign ? { id: 'gclid-seed', type: 'google' } : null,
            visits, firstSeen: firstAt, lastSeen: lastAt,
            fields: {
              ...(x[4] ? { 'products[]': String(x[4]).toLowerCase() } : {}),
              ...(campaign ? { campaign } : {}),
              ...(type === 'Chatbot' ? { chatbot_label: 'Chat with us' } : {})
            },
            sessions: Array.from({ length: Math.min(visits, 3) }, (_, n) => ({
              at: stampAt(x[5] + Math.min(visits - 1, 3) - n, 11 + ((i + n) % 7)),
              source: n ? 'Direct' : x[3],
              landing: `https://thexyra.ai${n ? '/' : page}`,
              referrer: n ? '' : (i % 3 === 0 ? 'https://www.google.com/' : ''),
              exit: `https://thexyra.ai${page}`,
              pages: n ? 1 : [1, 4, 2, 3, 6, 1][i % 6],
              seconds: n ? 30 + n * 17 : [12, 217, 64, 138, 402, 9][i % 6],
              country, city,
              device: ['Desktop', 'Mobile', 'Desktop', 'Tablet'][i % 4],
              browser: ['Chrome', 'Safari', 'Edge', 'Chrome'][i % 4],
              os: ['Windows', 'iOS', 'macOS', 'Android'][i % 4],
              utm: campaign && !n
                ? { source: 'google', medium: 'cpc', campaign, term: '', content: '' }
                : { source: '', medium: '', campaign: '', term: '', content: '' },
              types: [type], states: [state],
              journey: [
                { at: stampAt(x[5] + Math.min(visits - 1, 3) - n, 11 + ((i + n) % 7)),
                  url: `https://thexyra.ai${n ? '/' : page}`,
                  title: n ? 'XYRA AI Accounting Software' : 'Pricing — XYRA',
                  seconds: n ? 30 : 86 },
                ...(n ? [] : [{ at: firstAt, url: 'https://thexyra.ai/book-demo',
                  title: 'Book a Free Demo — XYRA', seconds: 51 }])
              ]
            }))
          },
          notes: `Demo requested ${iso}. Contact: ${x[0]} · ${slug}@example.com · +971 5${i}0 ${100 + i * 7} ${2000 + i * 31}
`
            + `${x[4] ? `Wants ${x[4]} · ` : ''}${i % 3 === 0 ? 'Campaign: sept-launch · ' : ''}${city} · ${country}
`
            + `Landed on https://thexyra.ai${page}`,
          created: at(x[5]), origin: 'vizadtraq'
        };
      })
    ],
    acts: ACTIVITY_ROWS.map((x, i) => ({
      id: `ac${i + 1}`, subject: x[0], type: x[1], dealId: x[2], who: x[3],
      due: at(x[4]), done: x[5], notes: ''
    }))
  };
}
